import { STATUS_LABELS } from "@/lib/labels";

/**
 * Topologiya ekranining atamalari.
 *
 * Ombor xodimi kod bilan emas, SO'Z bilan ishlaydi: reyestrdagi
 * `A-STORAGE` unga hech narsa aytmaydi, «A ombor» esa aytadi.
 */

/**
 * Zona kodini OMBOR nomiga aylantiradi.
 *
 * A/B/C korpuslari mantiqan bitta omborga birlashtirilgan va
 * `warehouse_code` hamma yerda «A» bo'lib qoldi — u ekranda hech
 * narsani ajratmaydi. Xodim uchun ma'noli ajratgich zona kodida:
 * `A-STORAGE` → «A ombor».
 *
 * Shu sababli alohida «Zona» ustuni YO'Q: u ayni shu matnni
 * takrorlardi.
 *
 * `STORAGE` so'zi «ombor» bilan almashtiriladi: bitta tushuncha
 * ikki xil nomda yurmasligi kerak.
 */
export function zoneLabel(zoneCode: string): string {
  const code = (zoneCode || "").trim();
  if (!code) return "—";

  const parts = code.split("-");
  const named = parts.map((part) => ZONE_PARTS[part.toUpperCase()] ?? part);
  return named.join(" ");
}

const ZONE_PARTS: Record<string, string> = {
  STORAGE: "ombor",
  DOCK: "dok",
  PICK: "terish",
  RECEIPT: "qabul",
  SHIP: "jo'natish",
  CUSTOMS: "bojxona",
  RETURN: "qaytarish",
  DEFECT: "brak",
};

/**
 * ABC klassi — ekranda «Hudud».
 *
 * Tovarning ABC toifasi bilan ADASHTIRMASLIK uchun: bu
 * yacheykaning qayerda turgani (TZ LOC-002), tovarning aylanma
 * tezligi emas.
 */
export function zoneAreaLabel(abcZone: string): string {
  const code = (abcZone || "").trim().toUpperCase();
  if (!code) return "—";
  return `${code} hudud`;
}

/** Yacheyka turi — nomi bilan (Y1 → «mayda terish»). */
export function cellTypeLabel(cellType: string): string {
  const code = (cellType || "").trim();
  if (!code) return "—";
  return STATUS_LABELS[code] ?? code;
}

/** Yacheyka vazifasi (MX, OX, qabul…). */
export function functionLabel(value: string): string {
  const code = (value || "").trim();
  if (!code) return "—";
  return STATUS_LABELS[code] ?? code;
}
